import React, { useState } from 'react';
import { Link }            from 'gatsby';

import PageContext from '../context';

import { i18n } from '../i18n';

import * as css from './index.module.css';

export function getPart(idx) {
    return idx ? `/part-${idx + 1}` : '';
}

export default function PageNav({ isBottom = false }) {
    const navKeys                 = Object.keys(i18n('nav', { md : false })).filter(key => key !== '0');
    const [ showNav, setShowNav ] = useState();

    return <PageContext.Consumer>
        {({ part, lang }) => (
            <div className={css.navBody}>
                {isBottom ? (<h3 className={css.navHeader}>{i18n(`part${part}.continue`)}</h3>) : null}

                <div className={css.navWrap}>
                    <button className={showNav ? css.btn : css.hideBtn} onClick={() => setShowNav(!showNav)}>
                        { i18n(`nav.${part}`) }
                    </button>

                    <nav className={showNav ? css.showNav : css.hideNav}>
                        {navKeys.map((key, idx) =>
                            <Link key={key} to={`/${lang}/new-player-guide${getPart(idx)}`} className={part === idx + 1 ? css.selected : css.notSelected}>
                                { i18n(`nav.${key}`) }
                            </Link>
                        )}
                    </nav>

                </div>
            </div>
        )}
    </PageContext.Consumer>;
}
